<template>
    <div class="fill flex-box col nopadding">
        <div class="flex-box-bd fillw" style="position: relative;">
            <img class="fill" style="z-index:-1;width: 100%;height:100%" :src="img_path+'bg.jpg'">
            <div class="fillh flex-box nopadding" style="width: 1200px;margin: 0 auto">
                <div style="width: 35%"></div>
                <div class="flex-box-bd bg-white flex-box nopadding col box-inshadow" style="height: 500px">
                    <div class="flex-box-bd flex-box pd-30" style="position: relative;">
                        <div class="flex-box nopadding col-center box-inshadow login-box-left">
                            <div class="flex-box-bd"></div>
                            <img class="img-80 round-5" :src="img_path_com + 'logo200.png'">
                            <div class="mg-top30 f-bd f25" style="color:#29faff">欢迎使用 小超聚能平台</div>
                            <div class="flex-box-bd"></div>
                            <div class="flex-box-bd"></div>
                        </div>
                        <div class="flex-box col fillh" style="width:300px;border-right: #999 dashed 1px;">
                            <div class="flex-box-bd"></div>
                            <div class="f25">{{$t('scan_login')}}</div>
                            <div class="img-200 relative" style="margin: 0 auto">
                                <vue-qr :text="code_url" :size="200"></vue-qr>
                                <div class="mask abs flex-box col" v-if="scan_login_timeout">
                                    <div class="flex-box-bd"></div>
                                    <div class="f18 f-white">{{$t('ewm_timeout')}}</div>
                                    <div class="my-btn mg-10 bg-yellow" @click="reloadEwm">{{$t('reload_ewm')}}</div>
                                    <div class="flex-box-bd"></div>
                                </div>
                            </div>
                            <div class="f14 f-gray">{{$t('scan_login_ts')}}</div>
                            <div class="flex-box-bd"></div>
                        </div>
                        <div class="flex-box col fillh width-300" style="margin: 0 auto">
                            <div class="flex-box nopadding tab">
                                <div class="f20 mg-right20 curr pd-bottom5">{{$t('code_login')}}</div>
                                <div class="f20 pd-bottom5 f-gray">{{$t('mobile_login')}}</div>
                            </div>
                            <div class='my-input-box mg-top50'>
                                <div class="my-input-img">
                                    <img :src="img_path + 'user_code_tag.png'">
                                </div>
                                <input v-model="formData.user_code" class="my-input round-5 f16" :placeholder="$t('input_user_code')">
                            </div>
                            <div class='my-input-box mg-top20'>
                                <div class="my-input-img">
                                    <img :src="img_path + 'user_pwd_tag.png'">
                                </div>
                                <input v-model="formData.user_pwd" @keyup="pwdKeyup" type="password" class="my-input round-5 f16" :placeholder="$t('input_user_pwd')">
                            </div>
                            <div class="mg-top50">
                                <div class="my-btn l" @click="login">{{$t('login')}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="tcenter pd-10 f-gray">{{$t('login_xy')}}</div>
                </div>
            </div>
        </div>
        <div class="flex-box bg-f8">
            <div class="flex-box-bd"></div>
            <div class="tleft pd-top20 pd-bottom20 f16 f-black" style="width: 1200px">
                <div>© {{$t('cp_name')}} {{$t('sys_code')}} </div>
                <a class="flex-box nopadding f-black" target="_blank" href="https://beian.miit.gov.cn">
                    <div><img class="img-24 mg-top10" :src="img_path_com+'gongan.png'"></div>
                    <div class="mg-left5 f14 mg-top10">{{$t('sys_sn')}}</div>
                </a>
            </div>
            <div class="flex-box-bd"></div>
        </div>
    </div>
</template>

<script>
    import vueQr from 'vue-qr'
    export default {
        name: "login",
        components:{
            vueQr
        },
        data: function(){
            return{
                img_path:this.$config.imgUrl,
                img_path_com:this.$config.imgUrlCom,
                code_url: '',

                formData:{
                    user_code: "",
                    user_pwd: ""
                },

                //扫码
                scan_code: '',
                scan_login_timeout: false,
                login_flag: false //已登陆
            }
        },
        mounted:function(){
            document.title = this.$t('sys_name');
            window.changeRole = this.$base.changeRole; //切换角色时用

            this.getLoad();
        },
        methods: {
            pwdKeyup:function ($e){
                if($e.keyCode == 13){
                    this.login();
                }
            },
            reloadEwm:function(){
                this.scan_login_timeout = false;
                this.getLoad(true);
            },
            getLoad: function(show_msg = false) {
                this.$base.showLoading();
                this.$request.sendPost("user/before-login",{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.scan_code = data.scan_code;
                        this.code_url = this.$base.getLoginEwmCode(this.scan_code);

                        // this.chkScanLogin();
                        if(show_msg){
                            this.$base.msgSuccess(this.$t('refs_ok'));
                        }
                    }
                });
            },
            chkScanLogin:function(timeout = 100){ //200秒
                timeout --;
                var data = {
                    scan_code: this.scan_code
                }
                this.$request.sendPost('user/chk-scan-login',data,(success,data,error)=>{
                    if(success){ // 有结果
                        this.$base.setTokenCookie(data);
                    }
                    else{ // 无结果
                        this.noScanLogin(timeout);
                    }
                });
            },
            noScanLogin:function(timeout){
                console.log(this.login_flag);
                if(timeout > 0 && !this.login_flag){
                    setTimeout(()=>{
                        this.chkScanLogin(timeout);
                    },2000);
                }
                else{
                    this.scan_login_timeout = true;
                }
            },
            login:function () {
                //this.$base.getRole();return;
                if(this.formData.user_code == ""){
                    this.$base.alertInfo(this.$t('input_user_code'));
                    return;
                }
                if(this.formData.user_pwd == ""){
                    this.$base.alertInfo(this.$t('input_user_pwd'));
                    return;
                }
                this.formData.user_pwd = this.$base.toMD5(this.formData.user_pwd);
                this.$base.showLoading();
                this.$request.sendPost("user/login",this.formData,(success,data,error)=>{
                    this.$base.hideLoading();
                    this.formData.user_pwd = "";
                    if(success){
                        this.$base.setTokenCookie(data);
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
        },
        beforeDestroy: function () {
            this.login_flag = true;
        }
    }
</script>

<style scoped>
.tab .curr{
    color: #007dff;
    border-bottom: #007dff solid 2px;
    cursor: pointer;
}
.tab *{
    user-select: none;
}
.login-box-left{
    width: 350px;
    height: 500px;
    position: absolute;
    top: 0;
    left: -348px;
    background-color: rgba(0,21,42,0.6);
}
@media (min-height: 800px) {
    .login-box-left{
        width: 450px;
        height: 566px;
        transform: perspective(1000px) rotateY(35deg);
        position: absolute;
        top: -33px;
        left: -398px;
        background-color: rgba(0,21,42,0.6);
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue